<template>
    <v-dialog v-model="show" width="400" persistent no-click-animation>
        <div class="PermissionCreator">
            <div class="dialog-header">
                <div>{{ $f.tc('blackList') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <v-form v-model="formValid" @submit="submit" ref="form" style="padding: 12px">
                <div class="label">{{ $f.tc('phone') }}</div>
                <v-text-field
                    v-model="model.phone"
                    :rules="[formRules.ruleRequired, formRules.rulePhone]"
                    class="input-custom"
                ></v-text-field>
            </v-form>
            <div class="dialog-footer">
                <div class="btn-custom" @click="submit">{{ $f.tc('save') }}</div>
                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseFormMixin from "@/modules/fptai/mixins/DialogPromiseFormMixin";

export default {
    name: 'BlacklistCreator',
    mixins: [DialogPromiseFormMixin],
    data() {
        return {
            model: {
                phone: ''
            },
        }
    },
    computed: {
        headers() {
            return [
                {
                    text: this.$filters.capitalize(this.$t('phone')),
                    value: 'phone_number',
                    sortable: false
                },
                {
                    text: this.$filters.capitalize(this.$t('createBy')),
                    value: 'created_by',
                    sortable: true
                },
                {
                    text: this.$filters.capitalize(this.$t('action')),
                    value: 'action',
                    sortable: false,
                    type: 'custom',
                    id: 'action'
                }
            ]
        }
    },
    mounted() {
    },
    methods: {
        submitValidForm () {
            this.close()
            this.promise.resolve(this.model)
        }
    }
}
</script>

<style scoped lang="scss">
.PermissionCreator {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .btn-custom {
        margin-right: 8px !important;
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
        position: relative;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 8px
    }

    .v-select {
        .v-text-field__details {
            right: 40px !important;
        }
    }
}
</style>
